module.exports = __webpack_public_path__ + "a8b2fd8c54574b7651aca2833a8672a2.pdf";